<template>
  <v-card class="rounded-lg">
    <v-card-title class="d-flex justify-space-between align-start pa-6 pb-2">
      <div>
        <div class="text-h6 font-weight-bold">Pilih Channel Provider</div>
        <div class="text-body-2 grey--text text--darken-1 mt-1">
          Tentukan Channel Provider tujuan mapping
        </div>
      </div>
      <v-btn icon @click="onCancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-divider />

    <v-card-text class="pa-6">
      <v-alert
        text
        dense
        color="primary"
        class="d-flex align-center rounded-lg mb-6"
        icon="mdi-check"
      >
        <strong>{{ selectedCount }} merchant EDC</strong> siap di-mapping
      </v-alert>

      <div class="text-subtitle-2 font-weight-bold mb-2">
        Channel Provider Tujuan <span class="red--text">*</span>
      </div>

      <div class="provider-list-wrapper">
        <v-radio-group v-model="chosenId" :loading="loading" class="mt-0" hide-details>
          <v-radio
            v-for="provider in providers"
            :key="provider.id"
            :value="String(provider.id)"
            class="provider-radio rounded-lg pa-3 mb-2"
            :class="{ 'provider-radio--active': String(provider.id) === chosenId }"
          >
            <template v-slot:label>
              <span class="font-weight-medium ml-2">{{ provider.provider_name }}</span>
            </template>
          </v-radio>
        </v-radio-group>

        <div v-if="!loading && providers.length === 0" class="text-center grey--text py-4">
          Tidak ada channel provider tersedia.
        </div>
      </div>
    </v-card-text>

    <v-card-actions class="pa-6 pt-0">
      <v-btn
        color="primary"
        class="rounded-lg elevation-0 px-6"
        :disabled="!chosenId"
        @click="onConfirm"
      >
        Lanjut ke Konfirmasi
      </v-btn>
      <v-btn
        outlined
        color="primary"
        class="rounded-lg px-6 ml-2"
        @click="onCancel"
      >
        Batal
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ChannelProviderPicker',
  props: {
    selectedCount: { type: Number, default: 0 },
    providers: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    initialProviderId: { type: [String, Number], default: '' },
  },
  data() {
    return {
      chosenId: this.initialProviderId ? String(this.initialProviderId) : '',
    };
  },
  watch: {
    initialProviderId(val) {
      this.chosenId = val ? String(val) : '';
    },
  },
  methods: {
    onConfirm() {
      if (!this.chosenId) return;
      this.$emit('confirm', this.chosenId);
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>
.provider-list-wrapper {
  max-height: 320px;
  overflow-y: auto;
  padding-right: 4px;
}
.provider-radio {
  border: 1px solid #e0e0e0;
  background-color: #fafafa;
}
.provider-radio--active {
  border-color: #378595;
  background-color: #e6f3f4;
}
::v-deep .provider-radio .v-input--selection-controls__input {
  margin-right: 0;
}
</style>
